import { z } from 'zod';
import { PartnerMaterialAdminSchema } from '../../entities/partner-material/partner-material.schema';
/**
 * Delete Partner Material File Response
 * DELETE /api/v2/admin/partner-materials/:id/files/:locale
 */ export const DeletePartnerMaterialFileResponseSchema = z.object({
    data: PartnerMaterialAdminSchema
});

//# sourceMappingURL=delete-partner-material-file.schema.js.map